import { z } from 'zod';
import { DOCUMENT_ID_LENGTH } from '../constants';
import { requiredApplicationIdString } from '../helper';

export const validateDocumentRequestDocumentSchema = z.object({
  applicationId: requiredApplicationIdString(),
  documentRequestId: z.number().int().positive(),
  documentId: z.string().length(DOCUMENT_ID_LENGTH, `Document ID must be ${DOCUMENT_ID_LENGTH} characters long`),
});
